import * as React from "react"
import { AppTableSeeker } from "@components"
import { mergeDicts } from "@ui-seeker/utils"

import { CommonColumn } from "./@components"
import {
    actualPriceColumn, descriptionColumn, eyecatchsColumn, giftsImagesColumn, lastReviewDateColumn, legacyColumn, listPriceColumn, productRawColumn, productTitleColumn,
    retailerColumn, richContentTextColumn
} from "./columns"


export default function AdminScrapingDataReviewBaseTable({ id, data=[], title="", subtitle="", ...props }) {
    return <AppTableSeeker
        title={title}
        subtitle={subtitle}
        data={data}
        columns={[
            ...retailerColumn(),
            ...productRawColumn(),
            actualPriceColumn(),
            CommonColumn("brandRaw", "Brand", "percentageBrandRaw"),
            CommonColumn("clickAndCollect", "Click & Collect", "percentageClickAndCollect"),
            descriptionColumn(),
            CommonColumn("ean", "Ean", "percentageEan"),
            CommonColumn("externalSeller", "External Seller", "percentageExternalSeller"),
            eyecatchsColumn(),
            CommonColumn("freeShipping", "Free Shipping", "percentageFreeShipping"),
            CommonColumn("gifts", "Gifts", "percentageGifts"),
            giftsImagesColumn(),
            CommonColumn("numImages", "Images", "percentageNumImages", true),
            lastReviewDateColumn(),
            CommonColumn("lastReviewRating", "Last Review Rating", "percentageLastReviewRating"),
            CommonColumn("lastReviewTitle", "Last Review Title", "percentageLastReviewTitle"),
            legacyColumn(),
            listPriceColumn(),
            productTitleColumn(),
            CommonColumn("rating", "Rating", "percentageRating"),
            CommonColumn("numOpinions", "Reviews", "percentageNumOpinions"),
            CommonColumn("richContent", "Rich Content", "percentageRichContent"),
            richContentTextColumn(),
            CommonColumn("numRichContentImages", "Rich Content Images", "percentageNumRichContentImages"),
            CommonColumn("numRichContentVideos", "Rich Content Videos", "percentageNumRichContentVideos"),
            CommonColumn("numVideos", "Videos", "percentageNumVideos", true),
            CommonColumn("stockOnline", "Stock", "percentageStockOnline", true)
        ]}
        {...props}
        options={{
            print: false,
            ...props?.options,
            enhancedSetRowProps: () => mergeDicts({ sx: {
                "&:has(.is-open)": { backgroundColor: "warning.light" },
            }}, props?.options?.enhancedSetRowProps && props?.options?.enhancedSetRowProps())
        }}
    />
}